import { Injectable } from '@angular/core';
import { createStore, select, setProps, withProps } from '@ngneat/elf';
import {
  withActiveId,
  withEntities,
  upsertEntities,
  setActiveId,
  getAllEntities,
  getEntity,
  getActiveId,
  selectActiveId,
  selectEntity,
  getActiveEntity,
  hasEntity,
  selectActiveEntity,
  updateEntities,
} from '@ngneat/elf-entities';
import { entitiesStateHistory } from '@ngneat/elf-state-history';
import { Section } from '../models/section.model';
import { write } from './mutations';

const store = createStore(
  { name: 'renderer-sections' },
  withEntities<Section>(),
  withProps<{ hoverSection: string }>({ hoverSection: undefined }),
  withActiveId(),
);

@Injectable({ providedIn: 'root' })
export class RendererSectionsRepository {
  active$ = store.pipe(selectActiveEntity());
  activeId$ = store.pipe(selectActiveId());
  hoverSection$ = store.pipe(select((state) => state.hoverSection));

  has(sectionId: string) {
    return store.query(hasEntity(sectionId));
  }

  get(sectionId: string) {
    return store.query(getEntity(sectionId));
  }

  getAll() {
    return store.query(getAllEntities());
  }

  getActiveId() {
    return store.query(getActiveId);
  }

  getActive() {
    return store.query(getActiveEntity());
  }

  select(sectionId: string) {
    return store.pipe(selectEntity(sectionId));
  }

  upsert(section: Section) {
    store.update(upsertEntities(section));
  }

  update(sectionId: string, updater: (state: Section) => void) {
    store.update(updateEntities(sectionId, write<Section>(updater)));
  }

  updateActive(updater: (state: Section) => void) {
    store.update(updateEntities(this.getActiveId(), write<Section>(updater)));
  }

  setActive(formId: string) {
    store.update(setActiveId(formId));
  }

  setHoverSection(sectionId: string) {
    store.update(setProps(write((draft) => (draft.hoverSection = sectionId))));
  }

  reset() {
    store.reset();
  }

  getHistoryCollection() {
    return entitiesStateHistory(store);
  }
}
